<script>
import throttle from '@/helpers/throttleLodashLike';
import MaterialPlayer from "@/components/common/MaterialPlayer.vue";

export default {
    name: "AppNotificator",
    components: {MaterialPlayer},
    data() {
        return {
            posts: [],
            promoPost: null,
            //checkPostsToNotifyThrottled: () => {},
        }
    },
    mounted() {
        if (this.$store.me.is_teacher) {
            //this.checkPostsToNotifyThrottled = throttle(this.loadPostsCached, 10000, {trailing: false});
            this.loadPostsCached();
        }
    },
    computed: {
        /*notLessonPage() {
            // do implement
        },*/
    },
    methods: {
        async loadPostsCached() {
            this.posts = await this.$store.loadPosts({cache: {interpretHeader: false, ttl: 60 * 60 * 1000}});
        },
        showPostPromoOnce() {
            for (const post of this.posts) {
                const stateKey = `promoPostId_${post.id}`;
                if (localStorage.getItem(stateKey)) continue;

                const publishedDaysAgo = (Date.now() - new Date(post.published_at)) / (1000 * 60 * 60 * 24);
                if (publishedDaysAgo > 14) continue;

                localStorage.setItem(stateKey, 'done');
                this.promoPost = post;

                // @todo Серверне логування перегляду новини.

                //this.$notify?.promoOnce(stateKey, post.text + '<br>' + video);
                break;
            }
        }
    },
    watch: {
        $route (curr, old) {
            if (!curr) return;

            //this.checkPostsToNotifyThrottled();
            this.showPostPromoOnce();

            const ymd = new Date().toISOString().split('T')[0];
            const isAnyQuizPage = ['quiz', 'quizzes', 'quizzesRating', 'quizTraining', 'quizMaterials', 'quizzesMaterials'].includes(curr.name);
            const notLessonPage = (isAnyQuizPage || curr.name === 'profile' || curr.name === 'craftMaterials');

            /*if (new Date() < new Date('2024-09-01 07:00')) {
                this.$notify.promoOnce('key' + ymd, `content`);
            }*/

            if (this.$store.me.is_teacher && !this.$store.me.school?.id && notLessonPage) {
                this.$notify?.promoOnce('doSchoolSelect'+ymd, `💌 Шановний вчителю,<br>вкажіть свій навчальний заклад в «<a href="/school-select">Налаштуваннях</a>»,<br>💖 щоб ми могли видавати Вам персональні сертифікати 📜<br>за участь у Quiz чи інші освітні заходи 🧩<br>🤗 Дякуємо за Вашу роботу!`);
            }

            if (this.$store.me.is_teacher && !this.$store.me.phone && notLessonPage) {
                this.$notify?.promoOnce('doPhoneEnter', `💌 Шановний вчителю,<br> вкажіть, будь ласка, свій номер телефону на сторінці 👉 «<a href="/profile">Профілю</a>»,<br>щоб ми мали змогу зконтактувати з Вами при необхідності<br>(вручення сертифікатів, призів за майстер-класи, тощо..)<br> 🤝 Дякуємо за Вашу роботу!`);
            }

            /*if (this.$store.me.is_teacher && [2, 3, 4].includes(parseInt(this.$store.me.course.level)) && new Date() < new Date('2024-02-29') && notLessonPage) {
                this.$notify?.promoOnce('quizMaterialsCartoon2024', '👋 Вітаємо,<br>Вам та учням вже доступні <a href="/quiz/training" style="color: #9f4c4c;">«Матеріали для підготовки»</a> до наступного квізу на тему «Мультфільми і казки».<br>Готуйте Ваші команди та перемагайте! Бажаємо успіху! 🤝');
            }*/

            // 👋 🤏 🫶 🤝 🎈 🧩 🧣 🎓 🔔  🧮 📒📔📖📙📕📗📘📚 🔖 🪙 🏅 🏆 🥇 🥈 🥉
            // 👋 💌 💖 🤗 🤝 🤦 👈👉 👀 🍀 ☘ 🛟 ⏳ ⌚ ⏰ 🌨 ❄ ⛄ 🎁 🎀 📜 💼 🏁 🚩
        }
    },
}
</script>

<template>
    <div>
        <qip-modal ref="modalPlayer" @close="promoPost = null" v-if="promoPost" :opened="true">
            <div style="width: clamp(160px, 540px, 90dvw); margin: 0 auto;">
                <div v-html="promoPost.text"></div>
                <material-player v-if="promoPost.vimeo_url" :material="{vimeo_url: promoPost.vimeo_url}" />
                <!-- @todo Логувати перегляд на сервері -->
            </div>
        </qip-modal>
    </div>
</template>
